import CustomGetAppBanners from "./CustomGetAppBanner";

import { useBrandAppConfigWithFallback } from "@/api/cache/appConfigQueryOptions";

const addAppleSmartBanner = (appId: string) => {
  const metaTag = document.createElement("meta");
  metaTag.name = "apple-itunes-app";
  metaTag.content = `app-id=${appId}`;

  document.head.appendChild(metaTag);
};

const GetAppBanners = () => {
  const brandAppConfig = useBrandAppConfigWithFallback();

  if (!brandAppConfig) {
    return null;
  }

  return <CustomGetAppBanners />;
};

export default GetAppBanners;
